import React from "react";
import "./layout.css";

export default function Layout({ children, user, onLogout }) {
  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">CityMover</div>
        <div className="nav-group">
          {user && (
            <span style={{ fontWeight: 500 }}>
              {user.name}{" "}
            </span>
          )}
          {user && <button onClick={onLogout}>Logout</button>}
        </div>
      </header>
      <main className="content">{children}</main>
      <footer className="footer">v1.4.1 <a onClick={() => alert("The system is being updated with new features. While these improvements are made, things might look a little different. Please report any unexpected behavior to the admin.")}>beta</a></footer>
    </div>
  );
}
